import { render, staticRenderFns } from "./HighLimit_foodItem.vue?vue&type=template&id=6e2f4648&scoped=true"
import script from "./HighLimit_foodItem.vue?vue&type=script&lang=ts"
export * from "./HighLimit_foodItem.vue?vue&type=script&lang=ts"
import style0 from "./HighLimit_foodItem.vue?vue&type=style&index=0&id=6e2f4648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2f4648",
  null
  
)

export default component.exports